
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { BookOpen, ArrowLeft, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  // Common navigation patterns and suggestions
  const getNavigationSuggestions = (path: string) => {
    // Path patterns and their corresponding suggested destinations
    const patterns = [
      { includes: "/tag/", suggestion: "/categories", label: "Categories" },
      { includes: "/book/", suggestion: "/browse", label: "Browse Stories" },
      { includes: "/author/", suggestion: "/browse", label: "Browse Authors" },
      { includes: "/episode/", suggestion: "/browse", label: "Browse Stories" },
      { includes: "/settings", suggestion: "/", label: "Home" },
      { includes: "/profile", suggestion: "/", label: "Home" },
    ];

    // Find matching pattern
    const match = patterns.find(pattern => path.includes(pattern.includes));
    return match || { suggestion: "/browse", label: "Browse Stories" };
  };

  const suggestion = getNavigationSuggestions(location.pathname);

  useEffect(() => {
    document.title = "Page Not Found | ChapterSeed";
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center">
        <div className="text-center px-4 py-16 max-w-lg">
          <div className="inline-flex p-4 bg-chapterly-soft-purple rounded-full mb-4">
            <BookOpen className="h-12 w-12 text-chapterly-purple" />
          </div>
          <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
          <p className="text-xl text-gray-600 mb-8">
            Sorry, we couldn't find <span className="font-mono bg-gray-100 px-2 py-1 rounded">{location.pathname}</span>. The story continues elsewhere!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg">
              <Link to="/"><ArrowLeft className="mr-2 h-4 w-4" /> Return to Home</Link>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <Link to={suggestion.suggestion}><Search className="mr-2 h-4 w-4" /> {suggestion.label}</Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
